import { useClient } from '@modules/Clients/ViewClient/hooks';
import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

/**
 * Migas al abrir reglas de packaging desde un cliente (3PL).
 * Breadcrumbs when opening packaging rules from a client (3PL).
 */
export const PackagingRulesetsClientBreadcrumb = () => {
  const { clientId } = useParams<{ clientId: string }>();
  const { client } = useClient(clientId ? parseInt(clientId, 10) : 0);
  const { t } = useTranslation('packagingRulesetsModule');

  const breadcrumbs = useMemo(
    () => [
      { label: 'Clientes', path: '/clients' },
      { label: client?.name || 'cliente', path: `/clients/${clientId}` },
      { label: t('title') },
    ],
    [client?.name, clientId, t],
  );

  usePageNavigation({ breadcrumbs });

  return null;
};
